export default {
  // Search section
  searchPlaceholder: 'Please enter device SN',
  labelSearchPlaceholder: 'Please enter label',
  searchButton: 'Search',
  addDeviceAlgorithm: 'Add Device Algorithm',

  // Table columns
  deviceSN: 'Device SN',
  pullUrl: 'Pull URL',
  pushUrl: 'Push URL',
  label: 'Label',
  yoloModel: 'YOLO Model',
  confThreshold: 'Confidence Threshold',
  resolution: 'Resolution',
  createTime: 'Creation Time',
  createdBy: 'Created By',
  operation: 'Operation',

  // Modal titles
  addTitle: 'Add Device Algorithm',
  editTitle: 'Edit Device Algorithm',

  // Form fields
  deviceSNField: 'Device SN',
  deviceSNPlaceholder: 'Please enter device SN',
  pullUrlField: 'Pull URL',
  pullUrlPlaceholder: 'Please enter pull URL',
  pushUrlField: 'Push URL',
  pushUrlPlaceholder: 'Please enter push URL',
  sceneField: 'Scene',
  scenePlaceholder: 'Please select scene',
  yoloModelField: 'YOLO Model',
  yoloModelPlaceholder: 'Model path will be auto-filled after scene selection',
  confThresholdField: 'Confidence Threshold',
  confThresholdPlaceholder: '0~1',
  resolutionField: 'Resolution',
  resolutionPlaceholder: 'Please enter resolution',
  addressField: 'Inspection Address',
  addressPlaceholder: 'Please enter address',
  templateField: 'Inspection Template',
  templatePlaceholder: 'Please enter an array, e.g.: [{"label":"铆钉检测","require":"未发现铆钉","suggestion_no":"未发现铆钉，符合要求。","suggestion_has":"已发现铆钉，请及时清理。"}]',

  // Buttons
  edit: 'Edit',
  delete: 'Delete',
  cancel: 'Cancel',
  confirm: 'Confirm',

  // Validation messages
  deviceSNRequired: 'Please enter device SN',
  pullUrlRequired: 'Please enter pull URL',
  pushUrlRequired: 'Please enter push URL',
  sceneRequired: 'Please select scene',
  yoloModelRequired: 'Please select scene to auto-fill YOLO model',
  confThresholdRequired: 'Please enter confidence threshold',
  confThresholdInvalid: 'Please enter a value between 0 and 1',
  resolutionRequired: 'Please enter resolution',
  resolutionInvalid: 'Please enter a valid number',

  // Messages
  addSuccess: 'Device algorithm added successfully',
  editSuccess: 'Device algorithm updated successfully',
  deleteSuccess: 'Device algorithm deleted successfully',

  // Delete confirmation
  deleteConfirmTitle: 'Confirm Delete',
  deleteConfirmContent: 'Are you sure you want to delete the algorithm configuration for device {sn}?',
  deleteConfirm: 'Delete',
}
